import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useReportScheduleStatusReducer = () =>
	useSelector((state: ApplicationState) => state.reportScheduleStatus);
